<template>
    <div class="find-companies-root">
        <Header :label="$t('findcompanies.headerLabel')" overlap="small" />

        <MainLayout hideOnMobile="left right">
            <SearchModule
                slot="top"
                :filters="getFilters()"
                v-model="selected"
                v-on:clear:filter="clearFilters"
                :hasFiltersChanged="hasFiltersChanged"
            />
            <ProfileModule slot="left" />

            <FeaturedResource slot="left" />

            <Pagination slot="center" v-on:onBottom="nextPage">
                <CompanyList
                    with-layout-toggle
                    :label="$t('findcompanies.companyListLabel')"
                    :data="data()"
                    :isLoading="loading()"
                />
            </Pagination>

            <FeaturedCompanies v-if="showFeaturedCompanies" slot="right" />
            <FeaturedPositions v-if="showFeaturedPositions" slot="right" />
        </MainLayout>
    </div>
</template>

<script>
// Project components
import Header from '~/components/layouts/Header';
import MainLayout from '~/components/layouts/mainlayout/MainLayout';
import SearchModule from '~/shared/searchmodule/SearchModule';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule';
import CompanyList from '~/shared/CompanyList';
import FeaturedPositions from '~/components/smart/FeaturedPositions';
import FeaturedCompanies from '~/components/smart/FeaturedCompanies';
import Pagination from '~/components/miscellaneous/Pagination';
import FeaturedResource from '~/components/smart/FeaturedResource';

// Utils imports
import companyFilters from '~/utils/companyFilters';
import mapSelectedToFilters from '~/utils/mappers/mapSelectedToFilters';
import emptySelected from '~/utils/emptySelected';
import { FEATURE_COMPANIES_MODULE, FEATURE_POSITIONS_MODULE } from '~/router';

export default {
    name: 'FindCompanies',
    components: {
        Header,
        MainLayout,
        SearchModule,
        ProfileModule,
        CompanyList,
        FeaturedPositions,
        FeaturedCompanies,
        Pagination,
        FeaturedResource,
    },
    data: () => ({
        selected: null,
        page: 10,
        showFeaturedCompanies: FEATURE_COMPANIES_MODULE,
        showFeaturedPositions: FEATURE_POSITIONS_MODULE,
    }),
    computed: {
        companies() {
            return this.$interfaces.company.get(
                {
                    reactive: true,
                    ...mapSelectedToFilters(this.selected),
                },
                1,
                this.page
            );
        },
        filters() {
            return [];
        },
        hasFiltersChanged() {
            if (!this.selected) return false;

            let changed = false;

            let empty = Object.entries(emptySelected(this.filters));

            empty.forEach(([key]) => {
                let temp = this.selected[key];
                if (temp && JSON.stringify(temp) !== '{}') {
                    changed = true;
                }
            });

            return changed;
        },
    },
    methods: {
        data() {
            return this.companies.data;
        },
        loading() {
            return this.companies.loading;
        },
        error() {
            return this.companies.error;
        },
        clearFilters() {
            this.selected = emptySelected(this.filters);
        },
        getFilters() {
            return this.filters;
        },
        nextPage() {
            if (this.loading()) {
                return;
            }
            this.page += 1;
            // console.log('New page: ', this.page);
        },
    },
    watch: {
        filters(newVal) {
            if (!this.selected) {
                this.selected = emptySelected(newVal);
            }
        },
    },
    mounted() {
        this.selected = emptySelected(this.filters);
    },
};
</script>

<style scoped>
.find-companies-root {
    padding-bottom: 100px;
}
</style>
